import React, { useEffect, useState } from 'react';
import logo from '../../../Images/logo.jpg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MeditationCard from './MeditationCard';
import { loginData } from '../../../Utils/loginSlice';
import { toogleReload } from '../../../Utils/reloadSlice';
import { toogleMeditationAdd } from '../../../Utils/meditationAddSlice';

const MeditationSection = ({setEditMeditation}) => {
    const [meditationMap, setMeditationMap] = useState([]);
    const isReload = useSelector((store) => store.reload.isReload);
    const dispatch = useDispatch();
    const navigate = useNavigate();
  
    const handleSignOut = () => {
      dispatch(loginData("notexist"));
      navigate('/');
    }
  
    useEffect(() => {
      getData();
    }, [isReload]);
  
    const getData = async () => {
      const fetchData = await fetch('https://app-api.mokx.org/api/v1/meditation');
      const json = await fetchData.json();
      setMeditationMap(json.data.meditations);
    }
  
    return (
        <>
            <div className={`w-full ${meditationMap.length === 0 && "h-screen"}`}>
                <div className="w-full py-5 flex flex-col gap-7">
                    <div className="flex justify-between">
                        <h1 className="text-[#000] text-2xl font-montserrat font-bold">
                            Meditation
                        </h1>
                        <div className='flex gap-5'>
                            <div className='bg-clip flex justify-between items-center gap-3 rounded-[20px] px-3 text-[#FFF] cursor-pointer select-none' onClick={() => dispatch(toogleMeditationAdd())}>
                                Add Meditation
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 52 52" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M26 10.0049C26.8835 10.0049 27.5997 10.7211 27.5997 11.6046L27.5997 24.7097L40.7048 24.7096C41.5883 24.7096 42.3045 25.4258 42.3045 26.3093C42.3045 27.1927 41.5883 27.9089 40.7048 27.9089L27.5998 27.909L27.5998 41.0139C27.5998 41.8974 26.8836 42.6136 26.0002 42.6136C25.1167 42.6136 24.4005 41.8974 24.4005 41.0139L24.4004 27.909L11.2953 27.9089C10.4119 27.9089 9.69567 27.1927 9.69568 26.3092C9.69568 25.4258 10.4119 24.7096 11.2953 24.7096L24.4004 24.7097L24.4003 11.6046C24.4003 10.7211 25.1165 10.0049 26 10.0049Z" fill="#FFF"/>
                                </svg>
                            </div>
                            <div className='bg-clip flex justify-between items-center gap-3 rounded-[20px] px-3 text-[#FFF] cursor-pointer select-none' onClick={() => dispatch(toogleReload())}>
                                Reload
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512">
                                    <path fill="white" d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208s208-93.31 208-208S370.69 48 256 48Zm120 182.15a8.62 8.62 0 0 1-8.62 8.62h-59.54a8.61 8.61 0 0 1-6.09-14.71l22.17-22.17l-5.6-6.51a87.38 87.38 0 1 0-62.94 148a87.55 87.55 0 0 0 82.42-58.25A16 16 0 1 1 368 295.8a119.4 119.4 0 1 1-112.62-159.18a118.34 118.34 0 0 1 86.36 36.95l.56.62l4.31 5l14.68-14.68a8.44 8.44 0 0 1 6-2.54a8.61 8.61 0 0 1 8.68 8.63Z"/>
                                </svg>
                            </div>
                            <div className="w-[40px] h-[40px] pt-[3PX] bg-[#C4C4C4] rounded-full overflow-hidden cursor-pointer" onClick={() => handleSignOut()}>
                                <img className='scale-110' src={logo} alt="usericon" />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-wrap gap-9">
                        
                        {meditationMap.map((data) =>
                            <MeditationCard data={data} key={data._id} setEditMeditation={setEditMeditation} />
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default MeditationSection;
